module.exports = __webpack_public_path__ + "static/media/flappy-bird.8510b5ac.png";